<template>

    <div class="account-container">
        <Message :message="message" :type="type" v-if="message !== ''"></Message>
        <UserAccount :title="title" :user="user" @cancel="handleCancel" @save="handleSave"
                     form-mode="myAccount"></UserAccount>
    </div>
</template>

<script>
import UserAccount from '@/components/UserAccount.vue';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Message from '@/components/helpers/Message';

const UserRepository = RepositoryFactory.get('users');
const GroupsRepository = RepositoryFactory.get('groups');
export default {
  name: 'Account',
  components: { Message, UserAccount },
  data() {
    return {
      user: this.$store.getters.user,
      title: this.$t('myAccount'),
      message: '',
      type: 'info',
    };
  },
  methods: {
    handleSave(user) {
      const { token } = this.$store.getters;
      UserRepository.updateMyAccount(user, token).then(() => {
        this.$store.commit('update_user', user);
        this.$router.go();
        this.message = this.$t('account.messages.update');
      });
    },
    handleCancel() {
      this.user = this.$store.getters.user;
      this.message = this.$t('account.messages.cancel');
    },
  },
};
</script>

<style scoped>
    .account-container {
        width: 100%;
    }
</style>
